<template>
  <div class="documents">
    <div class="container">
      <h1 class="title">How to Enrol</h1>
      <h2 class="subtitle">
       <a v-show="school === 'stjustins'" href="https://app.kidsoft.com.au/p/ooshzoneStJustins/find-a-place" target="_blank" >Follow this link</a>
       <a v-show="school === 'stgregs'" href="https://app.kidsoft.com.au/p/ooshzoneStGreg/find-a-place" target="_blank" >Follow this link</a>
       <a v-show="school === 'maryimmaculate'" href="https://app.kidsoft.com.au/p/ooshzonemaryimmaculate/find-a-place" target="_blank" >Follow this link</a>
      </h2>
      <div class="columns documents">
      <div class="column">
      <p class="right">Select from which option below suits you, i.e if you have a parent portal account linked to another service please simply select login as an existing user.</p>
      </div>
      <div class="column left">
      <img src="../../../static/enrol/portal-homepage.png" />
      </div>
      </div>
 <div class="columns">
      <div class="column right">
      <img v-show="school === 'stjustins'" src="../../../static/enrol/portal-step2-stjustins.png" />
      <img v-show="school === 'stgregs'" src="../../../static/enrol/portal-step2-stgregs.png" />
      <img v-show="school === 'maryimmaculate'" src="../../../static/enrol/portal-step2-maryimmaculate.png" />
      </div>
      <div class="column left">
      <p>
You will then move to the find a place tab, as shown below.</p>
<p>Once there please select yes to knowing the name of the service you wish to enrol in. </p>
<p>Group Name – <strong>Oosh Zone Australia</strong></p>
<p v-show="school === 'stjustins'">Service Name – <strong>Ooshzone Australia St Justin’s Catholic Junior School</strong></p>
<p v-show="school === 'stgregs'">Service Name – <strong>Ooshzone Australia St Gregory’s Catholic Junior School</strong></p>
<p v-show="school === 'maryimmaculate'">Service Name – <strong>Ooshzone Australia Mary Immaculate</strong></p>
<p>Add in details of the child and then submit.</p>
      </div>
 </div>
 <div class="columns documents">
      <div class="column right">
<p>Once you have submitted this record you will be asked to finalise your waiting list entry.</p>
      </div>
      <div class="column left">
      <img src="../../../static/enrol/portal-step3.png" />
      </div>
 </div>
      <h2 class="subtitle documents">
        Enrolment Complete!
      </h2>
      <!-- <div class="columns is-multiline is-centered">
        <div :key='doc.name' v-for="doc in documents" class="column is-3">
        <a :href="'./../static/documents/' + doc.path" download :class="['is-medium is-outlined button is-dark' ]" basic :key='doc.name'>{{ doc.name }}</a>
        </div>
      </div>-->
      <!-- <aside class="menu">
        <p v-show="school === 'stjustins'" class="menu-label">St Justin’s Catholic Primary School</p>
        <ul v-show="school === 'stjustins'" class="menu-list">
          <li>
            <a :href="'../static/documents/' + documents[0].path" target="_blank">Enrol online</a>
          </li>
          <li>
            <a :href="'../static/documents/' + documents[1].path" target="_blank">How to enrol</a>
          </li>
        </ul>
      </aside> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Documents',
  props: ['school'],
  data () {
    return {
      documents: [
        {
          name: `St Justin's Enrol`,
          path: 'StJustins/St Justins Enrolment Form.pdf',
          color: 'is-info'
        },
        {
          name: `How to enrol`,
          path: 'StJustins/St Justins Handbook.pdf',
          color: 'is-link'
        },
        {
          name: 'Direct Debit Form',
          path: 'DirectDebitForm.pdf',
          color: 'is-success'
        },
        {
          name: `St Gregs's Enrolment Form`,
          path: 'StGregs/St Gregs Enrolment Form.pdf',
          color: 'is-info'
        },
        {
          name: `St Gregs's Handbook`,
          path: 'StGregs/St Gregs Handbook.pdf',
          color: 'is-link'
        },
        {
          name: 'Direct Debit Form',
          path: 'Direct Debit Form.pdf',
          color: 'is-success'
        },
        {
          name: 'Medication Record',
          path: 'Medication Record.pdf',
          color: 'is-warning'
        },
        {
          name: 'OOSH Zone Philosophy',
          path: 'Oosh Zone Philosophy.pdf',
          color: 'is-danger'
        },
        {
          name: 'Mary Immaculate Enrolment Form',
          path: 'MaryImmaculate/Mary Immaculate Enrolment Form.pdf',
          color: 'is-info'
        },
        {
          name: 'Mary Immaculate Handbook',
          path: 'MaryImmaculate/Mary Immaculate Handbook.pdf',
          color: 'is-link'
        },
        {
          name: 'Direct Debit Form',
          path: 'Direct Debit Form.pdf',
          color: 'is-success'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .right > img {margin-left: auto;}
  .left > img {margin-right: auto;}
.right {
  margin-top: auto;
  margin-bottom: auto;
  text-align: justify;
  font-size: 20px;
  font-weight: 500;
}
a {
  cursor: pointer;
}
a:hover {
  color: #e67e22;
}
p {
  margin: 20px 0;
}
.left {
  margin: auto;
  margin-left: auto;
  margin-right: 0;
  text-align: justify;
  font-size: 20px;
  font-weight: 500;
}
.half-col {
  display: inline-block;
  width: 40%;
}
.documents {
  padding: 30px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.button {
  margin: 20px;
}
.menu-list {
  margin-bottom: 40px;
}
.menu-list a {
  border: 2px solid transparent;
  border: 2px solid #111;
  /* border-radius: 0; */
  font-weight: 600;
}
.column {
  display: flex;
}
@media screen and (min-width: 769px) {
   .column {
     /* display: block; */

    flex-direction: column;
   }
}
@media screen and (max-width: 768px) {
  .right, .right > img {
    margin: auto;
  }
  .left, .left > img {
    margin: auto;
  }
  .column {
    flex-direction: column;
  }
}
.menu-list a:hover {
  background-color: #e67e22;
  /* border: 2px solid #111; */
  transition: background-color 0.4s;
  transition: border 0.4s;
}
.subtitle {
  font-weight: 600;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Enrol.vue